import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextButton } from '@components/library/button/index';
import {
  destroy as deleteRule,
  run as runRule } from '@api/v4/rules';

function RulesRow({ rule, setEditMode }) {
  const [deleteMode, toggleDeleteMode] = useState(false);
  // const [isExecuting, setIsExecuting] = useState(false);

  const formatDate = (railsDate) => {
    const jsDate = new Date(railsDate);
    return railsDate
      ? `${jsDate.getMonth() + 1}/${jsDate.getDate()}/${jsDate.getFullYear().toString().substr(-2)}`
      : null;
  };

  // const triggerRuleOnResource = () => {
  //   setIsExecuting(true);
  //   runRule(rule.key).then(() => {
  //     Notify.create({
  //       title: t("Rule Executing"),
  //       type: "success"
  //     });
  //   }).catch(() => {
  //     setIsExecuting(false);
  //     Notify.create({
  //       title: t("Failed to execute rule"),
  //       body: t("Please try again."),
  //       type: "error"
  //     });
  //   });
  // };

  const renderRule = () => {
    const { scopable_names, type, enforce, actionable_names, created_at } = rule;
    return (
      <React.Fragment>
        <span className="fifteen rule-name padding">
          { type }
        </span>
        <span className="thirty limited-height padding bf-scroll-element">
          { scopable_names }
        </span>
        <span className="twenty limited-height padding bf-scroll-element">
          { actionable_names }
        </span>
        <span className="ten center">
          { enforce.toString() }
        </span>
        <span className="ten center">
          { formatDate(created_at) }
        </span>
        <span className="five center">
          <TextButton
            className="edit-rule"
            onClick={() => setEditMode()}
            type="button"
          >
            <span className="bff-edit" />
          </TextButton>
        </span>
        <span className="five center">
          <button
            className="delete-rule"
            onClick={() => toggleDeleteMode(!deleteMode)}
            onKeyUp={() => toggleDeleteMode(!deleteMode)}
            type="button"
          >
            <span className=" bff-trash" />
          </button>
        </span>
      </React.Fragment>
    );
  };

  const deleteTags = () => {
    deleteRule(rule.key).then(() => {
      document.querySelectorAll("a.nav-link[href='rules']")[0].click();
      Notify.create({
        title: t("Rule Removed"),
        type: "success"
      });
    }).catch(() => {
      Notify.create({
        title: t("Deletion Failed"),
        body: t("Please try again."),
        type: "error"
      });
    });
  };

  const renderDelete = () => (
    <div className="delete-rule-mode">
      <span className="delete-text">Are you sure you want to delete this rule?</span>
      <div className="delete-buttons">
        <button
          className="button tertiary md cancel"
          type="button"
          onClick={() => toggleDeleteMode(false)}
        >
          {t("Cancel")}
        </button>
        <button
          className="button warning md"
          type="button"
          onClick={deleteTags}
        >
          {t("Delete Rule")}
        </button>
      </div>
    </div>
  );

  return deleteMode ? renderDelete() : renderRule();
}

RulesRow.propTypes = {
  rule: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    scope: PropTypes.object,
    enfore: PropTypes.bool,
    actionable_type: PropTypes.string,
    actionable_names: PropTypes.string,
    scopable_names: PropTypes.string,
  }).isRequired,
  setEditMode: PropTypes.func.isRequired
};

export default RulesRow;
